import { createApiSlice } from "@common";
import { CRUD_CONTRACT_STATUS } from "@routes";

const apiConfig = [
  {
    name: "addContractStatus",
    method: "post",
    url: CRUD_CONTRACT_STATUS,
    stateKey: "message",
  },
  {
    name: "getContractStatus",
    method: "get",
    url: CRUD_CONTRACT_STATUS,
    stateKey: "data",
  },
  {
    name: "updateContractStatus",
    method: "put",
    url: CRUD_CONTRACT_STATUS,
    stateKey: "message",
  },
  {
    name: "deleteContractStatus",
    method: "delete",
    url: CRUD_CONTRACT_STATUS,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
"contractStatus",
 apiConfig, 
 customReducers);
const contractStatusSlice = slice;

export default contractStatusSlice.reducer;

export const {
  addContractStatus,
  getContractStatus,
  updateContractStatus,
  deleteContractStatus,
} = thunks;

export const { rowSelect } = actions;
